import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function CursAbcForWho() {
  const forWho = ['Persoane care simt că nu își ating potențialul financiar, chiar dacă muncesc mult. Știi că poți mai mult, dar ceva te ține pe loc.', 'Oameni care vor libertate financiară și stabilitate, dar au credințe limitative despre bani și succes pe care le repetă inconștient.', 'Antreprenori sau angajați care vor mai mult, dar se simt blocați mental. Nu e vorba de strategie, ci de ce se întâmplă în interior.'];
  const notForWho = ['Persoane care caută soluții rapide, fără muncă interioară. Acest curs cere implicare, practică și timp.', 'Cei care nu cred că mentalitatea influențează banii și vor doar tehnici financiare concrete.', 'Oameni care nu aplică ceea ce învață. Fără exerciții și fără practica afirmațiilor, schimbările nu vin.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-880">
      <div className="max-w-6xl mx-auto px-6" data-id="element-881">
        <SectionHeading title="Pentru cine este cursul ABC-ul Prosperității" data-id="element-882" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-883">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-884">
            <div className="flex items-center gap-4 mb-8" data-id="element-885">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-886">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-887" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-888">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-889">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-890">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-891" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-892">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-893">
            <div className="flex items-center gap-4 mb-8" data-id="element-894">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-895">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-896" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-897">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-898">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-899">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-900" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-901">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-902">
          <CTAButton data-id="element-903" />
        </motion.div>
      </div>
    </section>;
}